import { getOrCreateLocalId, getLoginInfoPromise } from './common'
import Axios from './axios'
import jsCookie from 'js-cookie'

interface IData {
    pageId: string,
    buttonId: string,
    vin: string,
    params?: Object
}

export const reportData = async (data: IData) => {
    let commitData = {}
    let vin = data.vin

    let uid = ''
    let userType = ''
    let appVer = ''
    // let appVer = /(?<=com.xiaopeng.mycarinfo\/)(\d+\.\d+\.\d+)/.exec(navigator.userAgent) ?
    // /(?<=com.xiaopeng.mycarinfo\/)(\d+\.\d+\.\d+)/.exec(navigator.userAgent)![0] : ''

    // 用户类型 0:游客 1:车主用户 2:普通用户 3:租客用户
    const xpUserInfo = JSON.parse(jsCookie.get('xpeng_user_info') || '{}')
    if (Object.keys(xpUserInfo).length > 0) {
        uid = xpUserInfo.uid
        userType = xpUserInfo.userType
    } else {
        await getLoginInfoPromise()
            .then(res => {
                uid = res.uid
                userType = res.carownerflag
                jsCookie.set('xpeng_user_info', JSON.stringify({uid: res.uid, userType: res.carownerflag}))
            })
            .catch(err => {})
    }

    commitData = {
        device: getOrCreateLocalId(), // 必填，设备唯一Id，H5取NLS
        brand: 'ua', // 必填，手机品牌，web用'ua'代替
        model: 'ua', // 必填，手机机型，web用'ua'代替
        platform: 'ua', // 必填，操作系统， web用'ua'代替
        sys_ver: 'ua', // 必填，操作系统版本号，web用'ua'代替
        app_name: '小鹏汽车', // 必填
        app_ver: appVer, // 必填，应用版本号
        // package_name: '', // APP必填，应用包名
        // app_build_code: '', // APP必填，应用构建号
        // app_phase: '', // 必填，应用构建阶段，如DEV、Alpha、RC、Release
        app_channel: '', // APP必填/涉及渠道必填，安卓：yingyongbao 苹果：AppStore H5活动页: 英文来源渠道
        service_name: 'web', // 必填，信号采集源，服务端参数，mobile(服务端参数)/travel(服务端参数)/mini_program(API入参-特殊处理)/web(服务器参数)
        t: Date.now(), // 必填，发送时的手机系统毫秒时间戳
        position: ',', // 必填，地点位置，用户最近一次定位GPS经纬度，无权限或其他原因取不到默认“,“
        msg: [{
            user_id: uid,
            user_type: userType,
            order_type: 3, // 未知
            vin: vin || '',
            nettype: 'Unknown', // 会话网络状态，2G/3G/4G/WIFI/Unknown
            time: Date.now(), // 埋点时间，毫秒级时间戳
            page_id: data.pageId, // 埋点页面id，以鼹鼠平台为准
            button_id: data.buttonId, // 埋点id，以鼹鼠平台为准
            para: data.params ? JSON.stringify(data.params) : JSON.stringify({}), // json字符串，支持多参数，如果没有内参则为"{}"（空json字符串）
        }], // 必填，报文内容，json格式存储
    }

    return Axios({
        url: '/app/web/reportData',
        method: 'post',
        headers: {
            'XP-Appid': 'xp_web',
        },
        data: commitData
    }).catch(err => {
        console.log('report data error', err)
    })
}
